import Logo from '../../../public/images/logos/logo_vertical.png';
import Image from 'next/image';

export const MediaError = () => {
    return (
        <div className="absolute inset-0 overflow-hidden">
            <Image fill className="grayscale object-contain" src={Logo} alt="Not Found Logo" />
        </div>
    )
}